import { AccordionKey } from "../accordion-keys/AccordionKeys.types";

export const STORAGE_KEY = "accordionState";
export const CHANNEL_NAME = "accordion-state";

export type AccordionStateMap = Partial<Record<AccordionKey, boolean>>;

export enum AccordionEvent {
  UPDATED = "accordion-state-updated",
  CLEARED = "accordion-state-cleared",
}

type AccordionChannelMessage =
  | {
      type: AccordionEvent.UPDATED;
      payload: AccordionStateMap;
    }
  | {
      type: AccordionEvent.CLEARED;
    };

export function isAccordionChannelMessage(value: unknown): value is AccordionChannelMessage {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  const v = value as Record<string, unknown>;

  if (v.type === AccordionEvent.CLEARED) {
    return true;
  }

  if (v.type === AccordionEvent.UPDATED) {
    return isAccordionStateMap(v.payload);
  }

  return false;
}

export function isAccordionStateMap(value: unknown): value is AccordionStateMap {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  return Object.values(value).every((v) => typeof v === "boolean");
}
